module.exports = __webpack_public_path__ + "static/img/1.4ee7e51f.png";